import { Alert } from '@solvhealth/jigsaw-v1';
import React, { PureComponent, Fragment } from 'react';
import styled from 'styled-components';
import { colors } from '../../constants/colors';
import { fontFamily, fontSize } from '../../constants/text';

const StyledErrorContainer = styled.div.withConfig({ componentId: 'sc-d74rq8-0' })`
  position: relative;
`;

const StyledErrorMessage = styled.div.withConfig({ componentId: 'sc-d74rq8-1' })`
  animation: pop-down 0.5s ease;
  color: ${colors.theWhiteAlbum};
  display: flex;
  font-family: ${fontFamily.book};
  font-size: ${fontSize.default};
  overflow: hidden;
  padding: 20px;
  text-align: left;
`;

const StyledErrorImage = styled.img.withConfig({ componentId: 'sc-d74rq8-2' })`
  height: 20px;
  margin: auto;
  padding: 0 20px 0 0;
  width: 20px;
`;

type Props = {
  error?: any;
  ratingDate?: string;
};

export default class AddReviewWarning extends PureComponent<Props> {
  render = () => {
    return (
      <>
        <Alert show={!!this.props.ratingDate} tone="warning" variant="banner">
          Looks like you've already submitted a review for this booking. If you submit another
          review, it will replace your old one!
        </Alert>
        <Alert show={!!this.props.error} tone="critical" variant="banner">
          Whoops! Something went wrong. Try again later.
        </Alert>
      </>
    );
  };
}
